import React from "react";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";
import { RadioGroup, RadioOption } from "common/radio";
import {
  FormControlLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
} from "@mui/material";
import { useFeatureFlags } from "features/FeaturesContext";
interface ICustomListSelectFieldProps {
  value: Option | null;
  setValue: (value: Option | null) => void;
  schema?: CustomFieldSchemaFragment | null;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
export const CustomListSelectField = ({
  value,
  setValue,
  schema,
  labelledById,
}: ICustomListSelectFieldProps) => {
  const { ff_release_13_design_system_components } = useFeatureFlags(
    "ff_release_13_design_system_components",
  );
  const options: RadioOption[] =
    schema?.optionChoices?.map((optionChoice) => ({
      label: optionChoice.value,
      value: optionChoice.id,
      "data-custom-css-value": optionChoice.value, // for form custom css
    })) || [];

  const handleChange = (selectedValue: string) => {
    const selectedOption = schema?.optionChoices?.find(
      (option) => option.id === selectedValue,
    );

    if (selectedOption) {
      setValue({
        colour: selectedOption.colour,
        value: selectedOption.value,
        id: selectedOption.id,
      });
    }
  };

  return ff_release_13_design_system_components ? (
    <RadioGroup
      label=""
      options={options}
      onChange={handleChange}
      value={value?.id || ""}
    />
  ) : (
    <MuiRadioGroup>
      {schema?.optionChoices?.map((option, idx) => (
        <FormControlLabel
          key={idx}
          value={value?.id || null}
          checked={value?.id == option.id}
          onChange={() =>
            setValue({
              colour: option.colour,
              value: option.value,
              id: option.id,
            })
          }
          data-custom-css-value={option.value} // for form custom css
          control={<Radio aria-labelledby={labelledById} value={option.id} />}
          label={option.value}
        />
      ))}
    </MuiRadioGroup>
  );
};
